/* eslint-disable max-len */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import ColoredIcon from '../../../components/globals/ColoredIcon';
import CompareTable from '../../../components/CompareTable';
import GlobalTheme from '../../../styled/GlobalTheme';
import { container } from '../../../styled/mixins';

import {
  ChevronDownIcon,
  ChevronUpIcon,
} from '../../../assets/icons/iconRepository';

const TableContainer = styled.div`
  ${container}
  ${GlobalTheme.breakpoints.down('md')}{
    padding-right: 10px;
    padding-left: 10px;
  }
`;

const Wrapper = styled.div`
  background-color: ${({ typeColor }) => (typeColor ? GlobalTheme.colors.white : GlobalTheme.colors.screenBackground)};
  padding: 66px 0 230px;
  ${({ pricingView, show }) => (pricingView && show) && `
    margin-top: 138px;
  `}
`;

const ShowPricingDetailsBox = styled.div`
  margin: 20px 0;
  display: none;
  justify-content: center;
  align-items: center;
`;

const ShowPricingDetails = styled.div`
color: ${({ color }) => (color)};
display: flex;
align-items: center;
cursor: pointer;
font-weight: 600;
font-size: 18px;
${GlobalTheme.breakpoints.up('md')}{
  font-size: 24px;
}
`;

const ShowPricingText = styled.p`
  margin: 0;
`;

const CompareHolder = ({ pricingView, show }) => {
  const [hasMorePricingDetails, setHasMorePricingDetails] = useState(show);
  return (
    <Wrapper
      typeColor={hasMorePricingDetails}
      pricingView={pricingView}
      show={hasMorePricingDetails}
    >
      <TableContainer>
        <CompareTable
          show={hasMorePricingDetails}
          showButtons
          pricingView={pricingView}
        />
        <ShowPricingDetailsBox>
          <ShowPricingDetails
            color={GlobalTheme.colors.primary}
            onClick={() => setHasMorePricingDetails(!hasMorePricingDetails)}
          >
            <ShowPricingText>
              <FormattedMessage
                id={hasMorePricingDetails ? 'k.hide.plan' : 'k.show.plan'}
                defaultMessage={hasMorePricingDetails ? 'Hide Plans Details' : 'Show Plans Details'}
              />
            </ShowPricingText>
            <ColoredIcon
              src={hasMorePricingDetails ? ChevronUpIcon : ChevronDownIcon}
              color={GlobalTheme.colors.primary}
            />
          </ShowPricingDetails>
        </ShowPricingDetailsBox>
      </TableContainer>
    </Wrapper>
  );
};

CompareHolder.propTypes = {
  pricingView: PropTypes.bool,
  show: PropTypes.bool,
};

CompareHolder.defaultProps = {
  pricingView: false,
  show: false,
};

export default CompareHolder;
